// Shared firmware-update decision logic, used by both the Devices dropdown
// (ConnectionStatus) and the prominent patch-header button (PatchForm) so the
// two entry points can never drift apart.

// True when the device is running firmware older than the latest available.
export function firmwareUpdateAvailable(device, latestFirmwareVersion) {
  if (!device || !latestFirmwareVersion) return false;
  return device.firmwareVersion.isOlderThan(latestFirmwareVersion);
}

// True when firmware can be installed over the device's current connection.
// USB always supports OTA; WiFi does only when the device advertises the
// wifi_ota capability, so devices on firmware predating WiFi OTA fall back to
// the "connect via USB" badge rather than an update button that cannot work.
export function canUpdateFirmwareOverConnection(device, capabilities) {
  if (!device) return false;
  if (device.connectionType === 'usb') return true;
  if (device.connectionType === 'http') {
    return capabilities?.capabilities?.wifi_ota === true;
  }
  return false;
}

// The object exposing runFirmwareUpdate() for the connected device: the
// CobsConnection wrapped by a USB device, or the HttpDeviceConnection itself
// over WiFi. Passed to FirmwareUpdateModal as its `connection`.
export function resolveFirmwareUpdateConnection(device) {
  if (!device) return null;
  return device.connectionType === 'http' ? device : device.connection;
}
